export const landingProtectionConstants = {
    LANDING_PROTECTION_LOADING_SPINNER: 'LANDING_PROTECTION_LOADING_SPINNER',
    LANDING_PROTECTION_SET_TOKEN: 'LANDING_PROTECTION_SET_TOKEN'
};
